window.createVisibilityObserver = function createVisibilityObserver(
  targetClass,
  callback,
  threshold = 0.1
) {
  if (typeof callback !== 'function') {
    return;
  }

  if (typeof threshold !== 'number' || threshold < 0 || threshold > 1) {
    threshold = 0.1;
  }

  function onElementVisible(entry) {
    if (entry.isIntersecting) {
      callback(entry.target);
    }
  }

  const observerOptions = {
    root: null,
    rootMargin: '0px',
    threshold: threshold,
  };

  const observer = new IntersectionObserver((entries) => {
    entries.forEach(onElementVisible);
  }, observerOptions);

  if (document.querySelector(`.${targetClass}`)) {
    document.querySelectorAll(`.${targetClass}`).forEach((el) => {
      observer.observe(el);
    });
  }
};

/* createVisibilityObserver('my-class', funcName, 0.05); */

window.lineTitlesFunc = function lineTitlesFunc(titlesArr) {
  let resizeTimeout = null;
  let resizeFrame = null;

  const setLineTitlesHeight = () => {
    let maxHeight = 0;

    titlesArr.forEach((title) => {
      title.style.minHeight = '';
    });

    titlesArr.forEach((title) => {
      const height = title.offsetHeight;
      if (height > maxHeight) {
        maxHeight = height;
      }
    });

    titlesArr.forEach((title) => {
      title.style.minHeight = maxHeight + 'px';
    });
  };

  const requestLineTitlesHeight = () => {
    if (resizeFrame) {
      cancelAnimationFrame(resizeFrame);
    }

    resizeFrame = requestAnimationFrame(() => {
      resizeFrame = null;
      setLineTitlesHeight();
    });
  };

  const runLineTitlesHeight = () => {
    setTimeout(requestLineTitlesHeight, 50);
  };

  const onLineTitlesResize = () => {
    if (resizeTimeout) {
      return;
    }

    resizeTimeout = setTimeout(() => {
      resizeTimeout = null;
      requestLineTitlesHeight();
    }, 150);
  };

  if (document.fonts && document.fonts.ready) {
    document.fonts.ready.then(runLineTitlesHeight).catch(runLineTitlesHeight);
  } else {
    window.addEventListener('load', runLineTitlesHeight, { once: true });
  }

  window.addEventListener('resize', onLineTitlesResize, { passive: true });
};

window.statsCountAnimationInit = function statsCountAnimationInit() {
  const statsCountElements = document.querySelectorAll('.js-count-animate');

  if (!statsCountElements.length) return;

  const statsEscapeRegexp = (statsValue) => statsValue.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');

  const statsParseSingleNumber = (statsNumberText) => {
    const statsNumberPart = statsNumberText.trim();

    if (!statsNumberPart) return null;

    const statsSpaceSeparatorMatch = statsNumberPart.match(/\d([\s\u00A0\u202F])\d/);
    const statsApostropheSeparatorMatch = statsNumberPart.match(/\d([’'])\d/);

    let statsNormalizedNumber = statsNumberPart
        .replace(/[\u00A0\u202F]/g, ' ');

    const statsHasComma = statsNormalizedNumber.includes(',');
    const statsHasDot = statsNormalizedNumber.includes('.');

    let statsDecimalSeparator = null;
    let statsThousandsSeparator = '';

    if (statsHasComma && statsHasDot) {
      const statsLastCommaIndex = statsNormalizedNumber.lastIndexOf(',');
      const statsLastDotIndex = statsNormalizedNumber.lastIndexOf('.');

      if (statsLastCommaIndex > statsLastDotIndex) {
        statsDecimalSeparator = ',';
        statsThousandsSeparator = '.';
      } else {
        statsDecimalSeparator = '.';
        statsThousandsSeparator = ',';
      }
    } else if (statsHasComma) {
      const statsCommaParts = statsNormalizedNumber.split(',');

      if (
          statsCommaParts.length === 2 &&
          statsCommaParts[1].length > 0 &&
          statsCommaParts[1].length <= 2
      ) {
        statsDecimalSeparator = ',';
      } else {
        statsThousandsSeparator = ',';
      }
    } else if (statsHasDot) {
      const statsDotParts = statsNormalizedNumber.split('.');

      if (
          statsDotParts.length === 2 &&
          statsDotParts[1].length > 0 &&
          statsDotParts[1].length <= 2
      ) {
        statsDecimalSeparator = '.';
      } else {
        statsThousandsSeparator = '.';
      }
    } else if (statsApostropheSeparatorMatch) {
      statsThousandsSeparator = statsApostropheSeparatorMatch[1];
    } else if (statsSpaceSeparatorMatch) {
      statsThousandsSeparator = statsSpaceSeparatorMatch[1];
    }

    let statsCleanNumber = statsNormalizedNumber;

    if (statsThousandsSeparator) {
      const statsThousandsRegexp = new RegExp(statsEscapeRegexp(statsThousandsSeparator), 'g');
      statsCleanNumber = statsCleanNumber.replace(statsThousandsRegexp, '');
    }

    if (statsDecimalSeparator && statsDecimalSeparator !== '.') {
      const statsDecimalRegexp = new RegExp(statsEscapeRegexp(statsDecimalSeparator), 'g');
      statsCleanNumber = statsCleanNumber.replace(statsDecimalRegexp, '.');
    }

    const statsFinalNumber = parseFloat(statsCleanNumber);

    if (Number.isNaN(statsFinalNumber)) return null;

    let statsDecimalsLength = 0;

    if (statsDecimalSeparator) {
      const statsPartsAfterDecimal = statsNormalizedNumber.split(statsDecimalSeparator);
      statsDecimalsLength = statsPartsAfterDecimal[1] ? statsPartsAfterDecimal[1].length : 0;
    }

    return {
      value: statsFinalNumber,
      decimals: statsDecimalsLength,
      decimalSeparator: statsDecimalSeparator,
      thousandsSeparator: statsThousandsSeparator
    };
  };

  const statsParseCountText = (statsText) => {
    const statsNumberRegexp = /[-+]?\d(?:[\d\s,.'’]*\d)?/g;
    const statsParts = [];
    let statsLastIndex = 0;
    let statsNumberIndex = 0;
    let statsMatch = null;

    while ((statsMatch = statsNumberRegexp.exec(statsText)) !== null) {
      const statsMatchedText = statsMatch[0];
      const statsMatchIndex = statsMatch.index;

      if (statsMatchIndex > statsLastIndex) {
        statsParts.push({
          type: 'text',
          value: statsText.slice(statsLastIndex, statsMatchIndex)
        });
      }

      const statsParsedNumber = statsParseSingleNumber(statsMatchedText);

      if (statsParsedNumber) {
        statsParts.push({
          type: 'number',
          index: statsNumberIndex,
          ...statsParsedNumber
        });
        statsNumberIndex += 1;
      } else {
        statsParts.push({
          type: 'text',
          value: statsMatchedText
        });
      }

      statsLastIndex = statsMatchIndex + statsMatchedText.length;
    }

    if (statsLastIndex < statsText.length) {
      statsParts.push({
        type: 'text',
        value: statsText.slice(statsLastIndex)
      });
    }

    const statsNumberParts = statsParts.filter((statsPart) => statsPart.type === 'number');

    if (!statsNumberParts.length) return null;

    return {
      parts: statsParts,
      numberParts: statsNumberParts
    };
  };

  const statsFormatCountValue = (
      statsValue,
      statsDecimals,
      statsDecimalSeparator,
      statsThousandsSeparator
  ) => {
    let statsFormattedValue = statsValue.toFixed(statsDecimals);
    let [statsIntegerPart, statsFractionPart] = statsFormattedValue.split('.');

    statsIntegerPart = statsIntegerPart.replace(/\B(?=(\d{3})+(?!\d))/g, statsThousandsSeparator || '');

    if (statsDecimals > 0 && statsFractionPart !== undefined) {
      return statsIntegerPart + (statsDecimalSeparator || '.') + statsFractionPart;
    }

    return statsIntegerPart;
  };

  const statsBuildCountText = (statsParsedData, statsValues) => {
    return statsParsedData.parts.map((statsPart) => {
      if (statsPart.type === 'text') {
        return statsPart.value;
      }

      return statsFormatCountValue(
          statsValues[statsPart.index],
          statsPart.decimals,
          statsPart.decimalSeparator,
          statsPart.thousandsSeparator
      );
    }).join('');
  };

  const statsPrepareVisibility = (statsElement) => {
    statsElement.style.opacity = '0';
    statsElement.style.transition = 'opacity 0.3s ease';
  };

  const statsLockElementWidth = (statsElement) => {
    if (!statsElement.hasAttribute('data-count-lock-width')) return;

    const statsElementWidth = statsElement.offsetWidth;
    if (!statsElementWidth) return;

    if (getComputedStyle(statsElement).display === 'inline') {
      statsElement.style.display = 'inline-block';
    }

    statsElement.style.minWidth = statsElementWidth + 'px';
  };

  const statsRevealPreparedElement = (statsElement) => {
    requestAnimationFrame(() => {
      statsElement.style.opacity = '1';
    });
  };

  const statsAnimateCount = (statsElement) => {
    if (!statsElement || statsElement.classList.contains('is-count-animated')) return;

    const statsParsedData = statsParseCountText(statsElement.textContent);
    if (!statsParsedData) return;

    statsElement.classList.add('is-count-animated');

    const statsDuration = parseInt(statsElement.dataset.countDuration, 10) || 1600;
    const statsStartValue = parseFloat(statsElement.dataset.countStart);
    const statsTargetValues = statsParsedData.numberParts.map((statsPart) => statsPart.value);
    const statsStartValues = statsParsedData.numberParts.map((statsPart, statsIndex) => {
      if (statsIndex === 0 && !Number.isNaN(statsStartValue)) {
        return statsStartValue;
      }

      return 0;
    });

    const statsStartTime = performance.now();

    const statsStepAnimation = (statsCurrentTime) => {
      const statsProgress = Math.min((statsCurrentTime - statsStartTime) / statsDuration, 1);
      const statsEaseProgress = 1 - Math.pow(1 - statsProgress, 2);

      const statsCurrentValues = statsTargetValues.map((statsTargetValue, statsIndex) => {
        const statsCurrentStartValue = statsStartValues[statsIndex];

        return statsCurrentStartValue + (statsTargetValue - statsCurrentStartValue) * statsEaseProgress;
      });

      statsElement.textContent = statsBuildCountText(statsParsedData, statsCurrentValues);

      if (statsProgress < 1) {
        requestAnimationFrame(statsStepAnimation);
      } else {
        statsElement.textContent = statsBuildCountText(statsParsedData, statsTargetValues);
      }
    };

    requestAnimationFrame(statsStepAnimation);
  };

  const statsPrepareElement = (statsElement) => {
    if (!statsElement || statsElement.classList.contains('is-count-ready')) return;

    statsLockElementWidth(statsElement);
    statsRevealPreparedElement(statsElement);
    statsElement.classList.add('is-count-ready');
  };

  const statsPrepareAllElements = () => {
    statsCountElements.forEach((statsElement) => {
      statsPrepareElement(statsElement);
    });
  };

  const statsWaitForFonts = () => {
    if (document.fonts && document.fonts.ready) {
      return document.fonts.ready.catch(() => Promise.resolve());
    }

    return new Promise((statsResolve) => {
      window.addEventListener('load', statsResolve, { once: true });
      setTimeout(statsResolve, 1200);
    });
  };

  statsCountElements.forEach((statsElement) => {
    statsPrepareVisibility(statsElement);
  });

  statsWaitForFonts().then(() => {
    statsPrepareAllElements();

    const statsCountObserver = new IntersectionObserver(
        (statsEntries, statsObserver) => {
          statsEntries.forEach((statsEntry) => {
            if (statsEntry.isIntersecting) {
              statsAnimateCount(statsEntry.target);
              statsObserver.unobserve(statsEntry.target);
            }
          });
        },
        {
          threshold: 0.35
        }
    );

    statsCountElements.forEach((statsElement) => {
      statsCountObserver.observe(statsElement);
    });
  });
};

window.statsCountAnimationInit();
